module.exports = __webpack_public_path__ + "img/Decentralized.dcff2979.svg";